// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from "@sentry/nextjs";
var SAMPLE_RATE = 0.1;
var SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
Sentry.init({
  ignoreErrors: ["Non-Error promise rejection", "NS_ERROR_STORAGE_CONSTRAINT", "null is not an object (evaluating 'e.type')", "The fetching process for the media resource", // Chromecast error https://sentry.io/organizations/inderes-oy/issues/3153331333/?project=6051318&query=is%3Aunresolved
  "Failed to execute 'send' on 'PresentationConnection'", "ResizeObserver loop completed with undelivered notifications", "Failed to read the 'sessionStorage' property from 'Window': Access is denied for this document"],
  dsn: SENTRY_DSN || "https://214e3f224d8a4d58a94d6a081fd3a5c0@o1061123.ingest.sentry.io/6051318",
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: SAMPLE_RATE,
  tracesSampler: function tracesSampler(samplingContext) {
    var _samplingContext$tran, _samplingContext$tran2;

    if (["GET /wp-login.php", "GET /api/healthcheck"].includes(samplingContext === null || samplingContext === void 0 ? void 0 : (_samplingContext$tran = samplingContext.transactionContext) === null || _samplingContext$tran === void 0 ? void 0 : _samplingContext$tran.name)) {
      return 0;
    }

    if ((samplingContext === null || samplingContext === void 0 ? void 0 : (_samplingContext$tran2 = samplingContext.transactionContext) === null || _samplingContext$tran2 === void 0 ? void 0 : _samplingContext$tran2.name) === "GET /api/proxy/[...path]") {
      return 0.05;
    }

    return SAMPLE_RATE;
  } // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps

});